<template>
  <el-dialog
    top="50px"
    width="1200px"
    title="Chỉnh sửa thông tin"
    :visible="visible"
    :show-close="!callingAPI"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('close')"
  >
    <el-tabs
      v-model="activeTab"
      type="border-card"
    >
      <el-tab-pane
        v-for="(group, index) in groups"
        :key="index"
        :label="group.name"
        :name="group.key"
      />
      <CardForm
        ref="cardForm"
        :key="activeTab"
        :form="form"
        :fields="fields"
        :disabled="callingAPI"
      />
    </el-tabs>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        :disabled="callingAPI"
        size="medium"
        @click="$emit('close')"
      >
        Đóng
      </el-button>
      <el-button
        type="primary"
        :loading="callingAPI"
        size="medium"
        @click="handleConfirm"
      >
        Lưu
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import CardForm from "../components/show/CardForm.vue";
import commonServices from "@/services/common";
import {
  notification,
  convertPayloadData,
  arrayToObject
} from "@/utils/common";
import constants from "@/config/constants";

export default {
  name: "ShowFormPopup",
  components: {
    CardForm
  },
  props: {
    item: Object,
    config: Object,
    visible: Boolean,
  },
  data() {
    return {
      form: {},
      callingAPI: false,
      activeTab: "",
      parentId: null,
    };
  },
  computed: {
    objectType() {
      return constants.OBJECT_TYPES.find((t) => t.value === this.config.type);
    },
    groups() {
      return (this.config.extra.groups || []).sort((a, b) => a.order - b.order);
    },
    selectedGroup() {
      return this.groups.find((t) => t.key === this.activeTab);
    },
    fields() {
      return (this.config.extra.fields || [])
        .filter((f) => this.selectedGroup.fields.includes(f.key))
        .sort((a, b) => a.order - b.order);
    },
  },
  beforeMount() {
    this.initFormData();
  },
  methods: {
    initFormData() {
      this.activeTab = this.groups[0].key;
      this.parentId = this.item.parent_id;
      this.form = JSON.parse(
        JSON.stringify({
          ...arrayToObject(this.config.extra.fields),
          ...this.item.extra,
        })
      );
    },
    handleConfirm() {
      this.$refs.cardForm.$refs.form.validate(async (valid) => {
        if (valid) {
          this.callingAPI = true;
          commonServices
            .update(
              this.config.type,
              convertPayloadData(this.config.extra.key, {
                ...this.item,
                parent_id: this.parentId,
                extra: {
                  ...this.item.extra,
                  ...this.form,
                },
              })
            )
            .then(() => {
              this.callingAPI = false;
              notification(
                this,
                "success",
                "update",
                `${this.config.extra.name}`
              );
              this.$emit('reload');
              this.$emit('close');
            })
            .catch(() => {
              this.callingAPI = false;
              notification(
                this,
                "error",
                "update",
                `${this.config.extra.name}`
              );
            });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.tab-form-popup {
  .el-dialog__body {
    .el-tabs__content {
      min-height: 50vh;
      max-height: 60vh;
      overflow: auto;
    }
  }
}
</style>
